export default {
  scanDate: '扫码日期',
  template: '模板名称',
  displayDetailClicks: '展示详尽点击信息',
  fromDate: '起始日期',
  endDate: '结束日期',
  season: '销售季',
  productCode: '产品代码',
  productName: '产品名称',
  totalInventory: '总库存',
  totalSellThrough: '总销售率',
  totalDisplayUnits: '门店展示总数',
  totalTaggedUnits: '绑定总数',
  totalSalesUnits: '总销售',
  periodSalesUnits: '期间销售量',
  scansNo: '扫码总次数',
  clicksNo: '点击总次数',
  scanUsersNo: '扫码用户总数',
  scanRate: '扫码率',
  clickRate: '点击率',
  scanUserRate: '扫码用户率',
  noOfScans: '扫码次数',
  noOfClicks: '点击次数',
  click1Name: '栏位1名称',
  click2Name: '栏位2名称',
  click3Name: '栏位3名称',
  click4Name: '栏位4名称',
  click5Name: '栏位5名称',
  click6Name: '栏位6名称',
  noOfClick1: '栏位1点击数',
  noOfClick2: '栏位2点击数',
  noOfClick3: '栏位3点击数',
  noOfClick4: '栏位4点击数',
  noOfClick5: '栏位5点击数',
  noOfClick6: '栏位6点击数',
  templateName: '模板名称',
  merchantName: '商户名称',
  traceCode: '溯源码',
  uid: 'UID',
  noScanUser: '扫码用户数',
  summaryReportPageError: 'Product Code is empty in ant scan log data on',
  fieldInfo: '栏位信息'
}
